import { createContext } from "react";

export const FoggleContext = createContext({});
